import React, { Component } from 'react';
import ConfirmModal from '../../../../jsx/modal/ConfirmModal';

export default class ConfirmAddressModal extends Component {
    render() {
        const { streetNumber, addressComponents, distanceData, 
                onClose, onYes, onNo, message,
                yesText, noText
        } = this.props
        let modalMessage = <div style={{textAlign:"center"}}>
            <div>{message}</div>
            
            <div className="mt-2"><strong>{lang.delivery_charge}</strong></div>
            <div style={{fontSize: "180%"}}>{distanceData.price_text}</div>

            <div className="mt-2"><strong>{lang.deliver_to}</strong></div>
            {
                addressComponents.map((component, index) => {
                    if (component) {
                        return <div key={index}>
                            {index == 0 && streetNumber ? streetNumber + ", " : ""}
                            {component}
                        </div>
                    }
                })
            }
        </div>

        return <ConfirmModal 
            message={modalMessage}
            buttonLayout="vertical"
            onYes={onYes}
            onNo={onNo}
            yesText={yesText}
            noText={noText}
            onClose={onClose}
        />
    }
}